import React, { useMemo } from "react";
import styled, { withTheme } from "styled-components";

import InputWithLabel from "common/InputWithLabel";
import CommonModal from "common/Modal";
import Button from "common/Button";
import useQuery from "utils/useQuery";
import useSessionStorage from "utils/useSessionStorage";
import usePosition from "utils/usePosition";

import { Business, LocationOn, Close } from "@material-ui/icons";

const ListOfFavs = styled.div`
  display: flex;
  flex-flow: column nowrap;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: flex-start;
  height: calc(100% - 175px);
`;
const LeftBlock = styled.div`
  display: flex;
  align-items: center;
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 36px);
  align-items: center;
  padding: 10px 18px;
`;
const Title = styled.p`
  margin: 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
`;
const Content = styled.div`
  margin-left: 15px;
`;
const Description = styled.p`
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
`;
const ContainerResult = styled.span`
  font-size: 14px;
  color: rgba(43, 61, 80, 0.8);
  font-weight: bold;
  margin-left: 15px;
`;
const BatchEdit = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledLink = styled.a`
  font-size: 14px;
  height: auto;
  background-color: #fff;
  border: 1px solid #eaecee;
  border-radius: 3px;
  margin: 0 15px 0 0;
  padding: 0.7rem 1rem;
  color: #e08230;
  cursor: pointer;
  font-weight: bold;
  opacity: 1;
  text-decoration: none;
  align-items: center;
  display: flex;
  justify-content: space-between;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

function RoutePlanning({ setToggleModal, toggleModal, setSelectedRoute, selectedRoute, theme }) {
  const query = useQuery();
  const { userPosition } = usePosition();

  const [startDestination, setStartDestination] = useSessionStorage(
    "startDestinationRoute",
    "Mein Standort"
  );
  const [endDestination, setEndDestination] = useSessionStorage("endDestinationRoute", "");

  const routeString = useMemo(() => {
    const start =
      startDestination === "Mein Standort" && userPosition?.latitude && userPosition?.longitude
        ? `${userPosition.latitude},${userPosition.longitude}`
        : startDestination;
    let str = start ? `${start}/` : ``;

    selectedRoute.forEach(company => {
      str += `${company.co_street},${company.co_zip},${company.co_city}/`;
    });

    if (endDestination) {
      str += `${endDestination}/`;
    }
    return encodeURI(str);
  }, [endDestination, selectedRoute, startDestination, userPosition]);

  return (
    <CommonModal
      isOpen={toggleModal === 6}
      onRequestClose={() => setToggleModal(4)}
      Icon={LocationOn}
      modalTitle="Routenplanung"
    >
      <FlexContainer style={{ padding: "0 20px" }}>
        <InputWithLabel
          value={startDestination}
          type="text"
          label="Start"
          placeholder="Ziel eingeben..."
          onChange={e => setStartDestination(e.target.value)}
          companySearch
          style={{ marginRight: "10px" }}
        />

        <InputWithLabel
          value={endDestination}
          type="text"
          label="Ziel"
          placeholder="Ziel eingeben..."
          onChange={e => setEndDestination(e.target.value)}
          companySearch
        />
      </FlexContainer>
      <ListOfFavs>
        {selectedRoute.length > 0 && <ContainerResult>Zwischenziele</ContainerResult>}
        {selectedRoute?.length > 0
          ? selectedRoute.map((c, index) => (
              <Row key={c.id}>
                <LeftBlock>
                  <Business />
                  <Content>
                    <Title title={c.co_name} alt={c.co_name}>
                      {c.co_name}
                    </Title>
                    <Description>{`${c.co_street}, ${c.co_zip} ${c.co_city}`}</Description>
                  </Content>
                </LeftBlock>
                <div title="Remove from route" alt="Remove from route">
                  <Close
                    style={{ color: "red", cursor: "pointer" }}
                    onClick={e => {
                      e.stopPropagation();
                      setSelectedRoute(prevState => prevState.filter(s => s.id !== c.id));
                    }}
                  />
                </div>
              </Row>
            ))
          : null}
      </ListOfFavs>
      <BatchEdit>
        <div>
          {query?.fromCompanySearch === "true" ? (
            <Button
              onClick={() => setToggleModal(4)}
              margin="0 15px 0 15px"
              color={theme.primaryColor}
              background="#fff"
              text="Zurück zur Firmensuche"
              border="1px solid #eaecee"
            />
          ) : null}
        </div>

        <div style={{ display: "flex" }}>
          <Button
            onClick={() => {
              setSelectedRoute([]);
              setEndDestination("");
              setStartDestination("Mein Standort");
            }}
            margin="0 15px 0 0"
            color={theme.primaryColor}
            background="#fff"
            title="Routenplanung zurücksetzen"
            alt="Routenplanung zurücksetzen"
            text="Routenplanung zurücksetzen"
            border="1px solid #eaecee"
          />
          <StyledLink
            title="Zur Route"
            alt="Zur Route"
            href={`https://www.google.de/maps/dir/${routeString}`}
            target="_blank"
          >
            <LocationOn /> Zur Route
          </StyledLink>
        </div>
      </BatchEdit>
    </CommonModal>
  );
}

export default withTheme(RoutePlanning);
